import { isDowngrade } from "../planActionHelpers";
import { PlanDowngradeScheduleSuccess } from "../PlanDowngradeScheduleSuccess";
import { useUpgradeFlowShellContext } from "../UpgradeFlowContext";
import { useUpgradePlanContext } from "../UpgradePlanContext";

export const ScheduledDowngradeSuccessRoute = () => {
  const { handleOnSuccess, successButtonLabel } = useUpgradeFlowShellContext();
  const { plan } = useUpgradePlanContext();

  return (
    <PlanDowngradeScheduleSuccess
      buttonLabel={successButtonLabel}
      onSuccess={handleOnSuccess}
      isPlanActionDowngrade={isDowngrade(plan?.plan_action)}
    />
  );
};
